import Service from '@/service/index.js';
import ProjectService from '../../../project.service.js';
import { transactionProjectStatus } from '@/utils/mixins/transaction-project-status.js';
import { errorMessage, successMessage } from '@/utils/message.js';
import Payment from '@/components/payment/payment.vue';
import UpdateConfirmInfo from '@/components/update-confirm-info/update-confirm-info.vue';
export default {
  components: {
    Payment,
    UpdateConfirmInfo
  },
  mixins: [transactionProjectStatus],
  props: {
    slides: {
      type: Array,
      default: []
    },
    projectInfo: {
      type: Object,
      default: {}
    },
    transfereeInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      id: '',
      specialStatus: '',
      projectStatusArr: [],
      projectTypeArr: [],
      projectId: null,
      bidTypeArr: [],
      galleryTop: [],
      galleryThumbs: [],
      updateConfirmData: {},
      showConfirm: false,
      showPayment: false,
      currentProjectId: '',
      dialogFormVisible: false,
      ruleForm: {
        refuseReason: ''
      },
      rules: {
        refuseReason: [
          { required: true, message: '请输入100字以内的驳回原因', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    projectCode() {
      if(this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
        return `${this.projectInfo.projectType}-${this.projectInfo.projectSubType}`;
      }
    },
    projectTypeText() {
      if (!this.projectTypeArr.length) { return ''; }
      const obj = this.projectTypeArr.find(item => item.code === String(this.projectInfo.projectType));
      if (obj) {
        const subObj = obj.list && obj.list.find(item => item.code === String(this.projectInfo.projectSubType));
        if (subObj) {
          return obj.value + ' · ' + subObj.value;
        } else {
          return obj.value;
        }
      } else {
        return '';
      }
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.specialStatus = this.$route.query.specialStatus;
    const arr = [
      ['projectStatusArr', 'PROJECT_STATUS'], ['projectTypeArr', 'PROJECT_TYPE'], ['bidTypeArr', 'BIDDING_METHOD']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
  },
  watch: {
    projectInfo(newValue) {
      if (newValue) {
        if (Number(newValue.signStatus) === 0) {
          // 70 已成交的状态
          if (70 <= newValue.status && newValue.status <= 90) {
            newValue.status = 70;
          } else if (newValue.status === 92 || newValue.status === 93 || newValue.status === 94 || newValue.status === 95) {
            newValue.status = 95; // 95 已结束的状态
          }
        } else {
          newValue.status = 50; // 50 报名中
        }
      }
    },
    slides(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.galleryThumbsLunbo();
          this.galleryTopLunbo();
        });
      }
    }
  },
  mounted() {
  },
  methods: {
    galleryThumbsLunbo() {
      this.galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 15,    // 在slide之间设置距离（单位px）
        slidesPerView: 5,    // 设置slider容器能够同时显示的slides数量
        loop: false,        // 设置为true 则开启loop模式
        freeMode: true,    // 默认为false，普通模式：slide滑动时只滑动一格
        loopedSlides: 5,    // 一般设置大于可视slide个数2个即可
        watchSlidesVisibility: true,   // 开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
        watchSlidesProgress: true   // 开启这个参数来计算每个slide的progress(进度、进程)
      });
    },
    galleryTopLunbo() {
      this.galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5,
        // 左右按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        thumbs: {        // thumbs组件专门用于制作带缩略图的swiper
          swiper: this.galleryThumbs
        }
      });
    },
    changeActiveIndex(index) {
      console.log(index);
      this.$refs.carousel.slideTo(index);
      this.$refs.carousel.update();
    },
    updateCarousel() {
      this.$refs.carousel.update();
    },
    confirmProjectById(id) {
      this.projectId = id;
      this.$confirm('确定要确认公告？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmProject();
      }).catch();
    },
    // 确认公告事件
    confirmProject() {
      ProjectService.confirmProjectById(this.projectId).then(res => {
        if (res && res.code === '0') {
          this.showConfirm = false;
          successMessage('确认公告成功');
          this.$router.push('/person-center/project/roll-out-project/list');
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('确认公告失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('确认公告失败');
        }
      });
    },
    paymentSuccess() {
      this.$emit('getDetail');
    },
    dispose() {
      this.$router.push('/person-center/project/roll-out-project/trans?id=' + this.id + '&tradeType=' + this.projectInfo.tradeType);
    },
    dialogFormclick() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('驳回公告后需要再次创建公告信息，确定要驳回公告吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },

    // 驳回公告提交
    submit() {
      let params =  {
        projectId: this.id,
        type: 1,
        remark: this.ruleForm.refuseReason
      };
      this.dialogFormVisible = false;
      ProjectService.rejectAnnouncement(params).then(res => {
        if (res && res.code === '0') {
          successMessage('驳回公告信息成功');
          window.location.reload();
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('驳回公告信息失败');
        }
      });
    }
  }
};
